// import styles from "./partnerTabs.module.scss";
import "./partnerTabs.scss";

interface ITabItem {
  tabId: number;
  text: string;
}

export default function PartnerTabs(props: {
  tabItems: ITabItem[];
  activeTabId: number;
  onClickTabItem?: (tabId: number) => void;
  className?: string;
}) {
  return (
    <div id="partner-tabs" className={`partner-tabs ${!!props.className ? props.className : ""}`}>
      <div className="tabs-inner">
        {props.tabItems.map((item) => (
          <TabItemButton
            key={item.tabId}
            text={item.text}
            isActive={props.activeTabId === item.tabId}
            onClick={() => {
              props.onClickTabItem && props.onClickTabItem(item.tabId);
            }}
          />
        ))}
      </div>
    </div>
  );
}

function TabItemButton(props: { text: string; isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={props.onClick}
      className={`tab-item-button ${props.isActive === true ? "active" : ""}`}
    >
      <span>{props.text}</span>
    </button>
  );
}
